<template>
  <div id="app">
    <!--material disgn icon cdn-->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@mdi/font@5.8.55/css/materialdesignicons.min.css">


    <!--    Agent side dashboard initialization ------------------------------------------------->
    <div v-if="currentRouteName == 'agentDashboard' || currentRouteName =='agentPending' ||
               currentRouteName=='agentApproved' ||
               currentRouteName == 'agentDeclined'|| currentRouteName == 'templateCreate' ||
               currentRouteName == 'documentCreate' || currentRouteName == 'templateEdit' ||
               currentRouteName == 'activityLog' || currentRouteName == 'profileView' ||
               currentRouteName == 'templateView' || currentRouteName == 'activityReportView' ||
               currentRouteName=='signatureCertificate' ||
               currentRouteName == 'expiredView' || currentRouteName=='PendingView' ||
               currentRouteName == 'CompletedView' || currentRouteName=='declinedView' ||
               currentRouteName=='templateList' || currentRouteName == 'envelopeStatusReportView' || currentRouteName == 'allDocumentsView' ||
               currentRouteName == 'assignToMeView' || currentRouteName=='templateListView'">

      <!--  Navbar component  -->
      <navbar :is-agent="true" :is-agent-signed-in="true"></navbar>
      <div class="columns mt-3  is-mobile">
        <div class="column is-2">
          <!--  Sidebar component -->
          <sidebar :isAgent="true"></sidebar>
        </div>

        <div class="column">
          <!-- Router view based on Sidebar selection -->
          <router-view/>
        </div>
      </div>
    </div>

    <!--  Customer side dashboard initialization ------------------------------------------------->
    <div v-else-if="currentRouteName == 'customerDashboard' ||
     currentRouteName == 'customerDashboardEsign' ||
     currentRouteName == 'customerDashboardHistory' ||
     currentRouteName == 'customerDashboardPending' ||
     currentRouteName == 'documentView' ||currentRouteName == 'completeView'">

      <!--  Navbar component  -->
      <navbar :isCustomer="true"></navbar>
      <!-- Router view based on Sidebar selection -->
      <router-view/>

    </div>

    <!-- Other views rather than dashboard views -->
    <div v-else>
      <router-view/>
    </div>

  </div>

</template>

<script>
import Navbar from '@/components/common/Navbar'
import Sidebar from "@/components/common/Sidebar";

export default {
  name: 'App',
  components: {
    Navbar,
    Sidebar
  },

  computed: {
    currentRouteName() {
      return this.$route.name;
    },

  },

  mounted() {

  },


  data(){
    return{

    }
  },

  methods:{

    checkUserRole: function (){
      var role = this.$root.user_role

      if(role == 1){
        this.departmentAdmin = true
      }else if(role == 2){
        this.internalStaff = true
      }
    }
  }




}
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}


/* stypes for app loading spinner */
.spinner{height:48px;width:48px;position:absolute;top:50%;left:50%;margin:-30px 0 0 -30px;-webkit-animation:rotation 1s infinite linear;-moz-animation:rotation 1s infinite linear;-o-animation:rotation 1s infinite linear;animation:rotation 1s infinite linear;border:6px solid rgba(0,0,0,.2);border-radius:100%;box-sizing: content-box;}
.spinner:before{content:"";display:block;position:absolute;left:-6px;top:-6px;height:100%;width:100%;border-top:6px solid rgba(0,0,0,.8);border-left:6px solid transparent;border-bottom:6px solid transparent;border-right:6px solid transparent;border-radius:100%;box-sizing:content-box;}
@-webkit-keyframes rotation{from{-webkit-transform:rotate(0)}to{-webkit-transform:rotate(359deg)}}
@-moz-keyframes rotation{from{-moz-transform:rotate(0)}to{-moz-transform:rotate(359deg)}}
@-o-keyframes rotation{from{-o-transform:rotate(0)}to{-o-transform:rotate(359deg)}}
@keyframes rotation{from{transform:rotate(0)}to{transform:rotate(359deg)}}


</style>


<style>
@font-face {
  font-family: "Adine Kirnberg";
  src: local("Adine Kirnberg"),
  url('/src/assets/fonts/Adine Kirnberg.ttf') format("truetype");
}
@font-face {
  font-family: "Brotherhood_Script";
  src: local("Brotherhood_Script"),
  url('/src/assets/fonts/Brotherhood_Script.ttf') format("truetype");
}
@font-face {
  font-family: "MonsieurLaDoulaise-Regular";
  src: local("MonsieurLaDoulaise-Regular"),
  url('/src/assets/fonts/MonsieurLaDoulaise-Regular.ttf') format("truetype");
}
@font-face {
  font-family: "Sacramento-Regular";
  src: local("Sacramento-Regular"),
  url('/src/assets/fonts/Sacramento-Regular.ttf') format("truetype");
}

@font-face {
  font-family: "AdineKirnberg-Alternate";
  src: local("AdineKirnberg-Alternate"),
  url('/src/assets/fonts/AdineKirnberg-Alternate.ttf') format("truetype");
}
@font-face {
  font-family: "AlexBrush-Regular";
  src: local("AlexBrush-Regular"),
  url('/src/assets/fonts/AlexBrush-Regular.ttf') format("truetype");
}
@font-face {
  font-family: "Quirlycues";
  src: local("Quirlycues"),
  url('/src/assets/fonts/Quirlycues.ttf') format("truetype");
}
@font-face {
  font-family: "SCRIPTIN";
  src: local("SCRIPTIN"),
  url('/src/assets/fonts/SCRIPTIN.ttf') format("truetype");
}
</style>


